import { http } from "@/core/api/";

const hrBaseURL = "api/hr";
const reportBaseURL = "api/report";
const hrServiceAssistantBaseURL = "api/hrserviceassistant";

export const getNecessitiesList = () => {
  return http.get(`${hrBaseURL}/necessities`);
};

export const getRequestStatusList = async academicYearId => {
  return http.get(`${hrBaseURL}/${academicYearId}/requeststatus`);
};

export const getRequests = async filters => {
  return await http.get(`${hrBaseURL}/requests`, {
    params: {
      ...filters
    }
  });
};

export const getRequeststudents = async (requestId, pageIndex) => {
  return await http.get(`${hrBaseURL}/requeststudents`, {
    params: {
      requestId: requestId,
      pageIndex: pageIndex
    }
  });
};

export const getStudentBySIE = async (
  requestId,
  studentSie,
  academicYearId
) => {
  return await http.get(
    `${hrBaseURL}/request/${requestId}/studentSearch/${studentSie}/${academicYearId}`
  );
};

export const createRequest = async data => {
  return await http.post(`${hrBaseURL}/request/add`, data);
};

export const saveRequest = async data => {
  return await http.post(`${hrBaseURL}/request/save`, data);
};

export const submitRequest = async data => {
  return await http.post(`${hrBaseURL}/request/submit`, data);
};

export const getRequestHistory = async requestId => {
  return await http.get(`${hrBaseURL}/request/${requestId}/history`);
};

export const getRequestOgp = async requestId => {
  return await http.get(`${hrBaseURL}/request/${requestId}/ogp`);
};

export const saveRequestOgp = async data => {
  return await http.post(`${hrBaseURL}/request/saveOgp`, data);
};

export const deleteRequest = async requestId => {
  return await http.delete(`${hrBaseURL}/request/${requestId}`);
};

export const getAssistanceTypes = async (peiId, categoryId) => {
  return await http.get(
    `${hrBaseURL}/assistancetypes?peiId=${peiId}&categoryId=${categoryId}`
  );
};

export const getInformationHeader = async requestId => {
  return await http.get(`${hrBaseURL}/informationheader/${requestId}`);
};

export const getRequestData = async requestId => {
  return await http.get(`${hrBaseURL}/${requestId}/requestPersonalStaffData`);
};

export const getStudentsByCustodian = async (custodianId, academicYearId) => {
  return await http.get(`${hrBaseURL}/groupstudentlist`, {
    params: {
      custodianIdCustodianUserId: custodianId,
      academicYearId
    }
  });
};

export const getAlternativeStudentsByCustodian = async (
  custodianId,
  academicYearId
) => {
  return await http.get(`${hrBaseURL}/groupalternativestudentlist`, {
    params: {
      custodianIdCustodianUserId: custodianId,
      academicYearId
    }
  });
};

export const getTargetRequestStatuses = async (
  newIrregularRequestModule,
  statusId,
  academicYearId
) => {
  const { data } = await http.get(
    `${hrBaseURL}/${newIrregularRequestModule}/${statusId}/${academicYearId}/targetrequeststatuses`
  );
  return data;
};

export const updateRequestStatus = async (
  newIrregularRequestModule,
  requestId,
  dto
) => {
  const rhInput = {
    statusId: dto.id,
    previousStatusId: dto.previousStatusId,
    statusDescription: dto.description,
    reason: dto.reason,
    authorizationNumber: dto.authorizationNumber,
    dailyShiftId: dto.dailyShiftId,
    recommendationTypeId: dto.recommendationTypeId,
    recommendsExisting: dto.recommendsExisting,
    assistantId: dto.assistantId
  };

  const { data } = await http.put(
    `${hrBaseURL}/changerequeststatus/${newIrregularRequestModule}/${requestId}`,
    rhInput
  );
  return data;
};

export const saveTeacherAnalysis = async data => {
  return await http.post(`${hrBaseURL}/request/saveTeacherAnalysis`, data);
};

export const saveCenterAnalysis = async data => {
  return await http.post(`${hrBaseURL}/request/saveCenterAnalysis`, data);
};

export const saveSaeeAnalysis = async data => {
  return await http.post(`${hrBaseURL}/request/saveSaeeAnalysis`, data);
};

export const checkAuthNumber = async authNumber => {
  const { data } = await http.get(
    `${hrBaseURL}/request/validateAuthNumber/${authNumber}`
  );
  return data;
};

export const getRecommendedInformation = async requestId => {
  const { data } = await http.get(
    `${hrBaseURL}/request/recommendedInfo/${requestId}`
  );
  return data;
};

export const getStudentParams = async () => {
  return await http.get(`${hrBaseURL}/request/studentparams`);
};

export const getRecommendationTypes = async () => {
  const { data } = await http.get(`${hrBaseURL}/recommendationtypes`);
  return data;
};

export const getRequestReport = async (isHistory, id) => {
  const { data } = await http.get(
    isHistory
      ? `${reportBaseURL}/${id}/getRequestsReport`
      : `${reportBaseURL}/${id}/getRequestReport`
  );

  return data;
};

export const getAssistantSchoolReport = async (
  academicYearId,
  locationSchoolId
) => {
  return await http.get(`${reportBaseURL}/assistantschool`, {
    params: {
      academicYearId,
      locationSchoolId,
    },
  });
};

// Service Assistants
export const getServiceAssistantSchools = async filters => {
  const { data } = await http.get(
    `${hrServiceAssistantBaseURL}/searchassistantschools`,
    {
      params: {
        academicYearId: filters.academicYearId,
        regionId: filters.regionId,
        municipalityId: filters.municipalityId,
        schoolId: filters.schoolId,
        pageIndex: filters.pageIndex
      }
    }
  );

  return data;
};

export const getServiceAssistantById = async id => {
  const { data } = await http.get(
    `${hrServiceAssistantBaseURL}/serviceassistant/${id}`
  );
  return data;
};

export const getServiceAssistantSchoolInformation = async (
  schoolId,
  academicYearId
) => {
  const { data } = await http.get(
    `${hrServiceAssistantBaseURL}/${schoolId}/${academicYearId}`
  );
  return data;
};

export const getServiceAssistantsList = async searchDTO => {
  const { data } = await http.get(
    `${hrServiceAssistantBaseURL}/serviceassistants`,
    {
      params: {
        academicYearId: searchDTO.academicYearId,
        schoolId: searchDTO.schoolId,
        regionId: searchDTO.regionId,
        searchInput: searchDTO.searchInput,
        pageIndex: searchDTO.pageIndex
      }
    }
  );
  return data;
};

export const saveServiceAssistantInformation = async assistantInfoDTO => {
  const { data } = await http.post(
    `${hrServiceAssistantBaseURL}/serviceassistantinfo/save`,
    assistantInfoDTO
  );

  return data;
};

export const updateServiceAssistantInformation = async assistantInfoDTO => {
  const { data } = await http.put(
    `${hrServiceAssistantBaseURL}/serviceassistantinfo/edit`,
    assistantInfoDTO
  );

  return data;
};

export const getAssistantServices = async contractNumber => {
  const { data } = await http.get(
    `${hrServiceAssistantBaseURL}/services/${contractNumber}`
  );

  return data;
};

export const addAssistantService = async (contractNumber, serviceId) => {
  return await http.post(
    `${hrServiceAssistantBaseURL}/services/${contractNumber}/add`,
    serviceId
  );
};

export const removeAssistantService = async (contractNumber, serviceId) => {
  return await http.post(
    `${hrServiceAssistantBaseURL}/services/${contractNumber}/remove`,
    serviceId
  );
};

export const getSchoolServiceAssistants = async params => {
  const { data } = await http.get(
    `${hrServiceAssistantBaseURL}/schoolserviceassistants`,
    {
      params
    }
  );
  return data;
};

export const getIsNotInMySchoolReasonOptions = () =>
  http.get(`${hrServiceAssistantBaseURL}/isNotInMySchoolReasonOptions`);

export const saveIsNotInMySchoolReason = payload =>
  http.post(`${hrServiceAssistantBaseURL}/isNotInMySchoolReason`, payload);

export const validateIsNotInMySchoolAction = (
  assistantId,
  schoolId,
  academicYearId
) =>
  http.get(`${hrServiceAssistantBaseURL}/validateisnotinmyschoolaction`, {
    params: {
      assistantId,
      schoolId,
      academicYearId,
    },
  });

export const assistantsAvailablesToAdd = async (payload) => {
  const { data } = await http.get(
    `${hrServiceAssistantBaseURL}/assistantsavailablestoadd`,{
      params: {
        ...payload,
      },
    }
  );

  return data;
};

export const addAssistantSchool = payload =>
  http.post(`${hrServiceAssistantBaseURL}/addassistantschool`, payload);

export const validateIsAnyAssistantCertified = (academicYearId, locationSchoolId) =>
  http.get(
    `${hrServiceAssistantBaseURL}/validateisanyassistantcertified`, {
      params: {
        academicYearId,
        locationSchoolId
      }
    }
  );

export const certifyAssistants = (academicYearId, locationSchoolId) =>
  http.put(
    `${hrServiceAssistantBaseURL}/certifyassistants/${academicYearId}/${locationSchoolId}`
  );

export const changeRequestStatusToPrevious = requestId =>
  http.put(`${hrBaseURL}/changerequeststatustoprevious/${requestId}`);

export const getResumeTypes = () => http.get(`${hrBaseURL}/resumetypes`);

export const getSaeeByRequest = async requestId => {
  return await http.get(`${hrBaseURL}/request/${requestId}/saee`);
};

export const updateMultipleRequestStatus = async dto => {
  const { data } = await http.put(
    `${hrBaseURL}/changemultiplerequeststatus/`,
    dto
  );
  return data;
};

export const updateCheckStatus = async dto => {
  const { data } = await http.put(`${hrBaseURL}/changescheckstatus/`, dto);
  return data;
};
export const getSaeeSchoolByRequest = requestId =>
  http.get(`${hrBaseURL}/request/${requestId}/saee/school`);

export const getSaeeTeacherByRequest = requestId =>
  http.get(`${hrBaseURL}/request/${requestId}/saee/teacher`);

export const getDeterminationLetterReport = (filters) =>
  http.get(`${reportBaseURL}/determinationletter`, {
    params: {
      ...filters,
    },
  });

export const revertIsNotInMySchoolReason = assistantSchoolId =>
  http.put(`${hrServiceAssistantBaseURL}/revertIsNotInMySchoolReason/${assistantSchoolId}`);
